<template>
  <div class="side-wrapper">
    <ul class="list-group list-group-flush">
      <li>
        <a
          v-for="(col, i) in sideColumns"
          :key="i"
          href="#"
          class="list-group-item list-group-item-action flex-column align-items-start side-item"
          :aria-current="i == selectedIndex ? 'true' : null"
          @click="onSectionClick(i)"
        >
          {{ col }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SideNavigation",
  props: {
    sideColumns: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedIndex: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  methods: {
    onSectionClick(index) {
      this.$emit("section-clicked", index);
    },
  },
};
</script>

<style scoped>
/* Styles will be inherited from parent components */
</style>
